import { Section } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { WithGet } from "./mixins/WithGet";

export class Endpoint extends BaseEndpoint("sections") {}

export const SectionEndpoint = WithGet<typeof Endpoint, Section>(Endpoint);
